export enum ValidationStatusEnum {
  pass = 'Pass',
  fail = 'Fail',
  warning = 'Warning',
  toBeImplemented = 'To Be Implemented'
}
